var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHybridIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 680.8 482.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-3{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_38-10);}.cls-4{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_38-11);}.cls-5{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_117-2);}.cls-6{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_118-4);}.cls-7{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_118-3);}.cls-8{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_118-2);}.cls-9{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_140-2);}.cls-10{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_140-4);}.cls-11{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_140-3);}.cls-12{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_148-2);}.cls-13{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_148-3);}.cls-14{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_119-5);}.cls-15{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_119-4);}.cls-16{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_119-3);}.cls-17{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_119-2);}.cls-18{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_162-2);}.cls-19{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_166-3);}.cls-20{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_166-7);}.cls-21{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_166-5);}.cls-22{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_166-2);}.cls-23{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_166-4);}.cls-24{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_166-6);}.cls-25{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_63-14);}.cls-26{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_63-13);}.cls-27{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_63-11);}.cls-28{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_63-10);}.cls-29{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_63-12);}.cls-30{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_182-2);}.cls-31{fill:url(#linear-gradient);}.cls-32{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_38);}.cls-33{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_27);}.cls-34{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_50);}.cls-35{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_48);}.cls-36{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_49);}.cls-37{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_55);}.cls-38{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_54);}.cls-39{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_22);}.cls-40{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_23);}.cls-41{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_94);}.cls-42{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_93);}.cls-43{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_67);}.cls-44{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_31);}.cls-45{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_74);}.cls-46{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_10);}.cls-47{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_63);}.cls-48{clip-path:url(#clippath);}.cls-49{fill:#f9f8f1;}.cls-50{fill:#f99e6f;}.cls-51{fill:#eef1ec;}.cls-52{fill:#f0eae3;}.cls-53{fill:#e8e6da;}.cls-54,.cls-55{fill:#fff;}.cls-56{fill:#ffe4d0;}.cls-57{fill:#f25b0a;}.cls-58{fill:#808688;}.cls-59{fill:#b5b0aa;}.cls-60{fill:#b6bebe;}.cls-61{fill:#667a85;}.cls-62{fill:#b24949;}.cls-63{fill:#c64621;}.cls-64{fill:#dbd6d0;}.cls-65{fill:#d9d3c5;}.cls-66{fill:#d7d6e2;}.cls-67{fill:#1e1415;}.cls-68{fill:#202029;}.cls-69{fill:#12140d;}.cls-70{fill:#0a6172;}.cls-71{fill:#a3a9ab;}.cls-72{fill:#6f7779;}.cls-73{fill:#455c6e;}.cls-74{fill:#9a8888;}.cls-75{fill:#56697c;}.cls-76{fill:#2f302c;}.cls-77{fill:#4aa4ac;}.cls-78{fill:#843a1d;}.cls-79{fill:#313434;}.cls-80{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_31-2);}.cls-81{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_48-2);}.cls-82{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_49-2);}.cls-83{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_49-3);}.cls-84{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_55-2);}.cls-85{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_55-3);}.cls-86{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_55-4);}.cls-87{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_55-8);}.cls-88{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_55-5);}.cls-89{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_55-6);}.cls-90{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_55-7);}.cls-91{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_38-9);}.cls-92{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_38-8);}.cls-93{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_38-2);}.cls-94{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_38-3);}.cls-95{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_38-4);}.cls-96{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_38-6);}.cls-97{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_38-5);}.cls-98{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_38-7);}.cls-99{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_54-4);}.cls-100{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_54-2);}.cls-101{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_54-3);}.cls-102{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_63-9);}.cls-103{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_63-6);}.cls-104{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_63-8);}.cls-105{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_63-7);}.cls-106{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_63-5);}.cls-107{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_63-3);}.cls-108{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_63-2);}.cls-109{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_63-4);}.cls-110{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_67-2);}.cls-111{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_74-6);}.cls-112{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_74-2);}.cls-113{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_74-5);}.cls-114{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_74-4);}.cls-115{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_74-3);}.cls-116{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_27-4);}.cls-117{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_27-3);}.cls-118{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_27-2);}.cls-119{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_27-5);}.cls-120{fill:#b8bfc1;stroke:#848886;strokeWidth:1.01px;}.cls-120,.cls-2{stroke-miterlimit:10;}.cls-2{stroke:#697273;strokeWidth:.81px;}.cls-2,.cls-55{opacity:.3;}.cls-121{fill:url(#linear-gradient-8);}.cls-122{fill:url(#linear-gradient-9);}.cls-123{fill:url(#linear-gradient-3);}.cls-124{fill:url(#linear-gradient-4);}.cls-125{fill:url(#linear-gradient-2);}.cls-126{fill:url(#linear-gradient-6);}.cls-127{fill:url(#linear-gradient-7);}.cls-128{fill:url(#linear-gradient-5);}.cls-129{opacity:.2;}.cls-130{opacity:.6;}.cls-131{fill:url(#linear-gradient-14);}.cls-132{fill:url(#linear-gradient-18);}.cls-133{fill:url(#linear-gradient-22);}.cls-134{fill:url(#linear-gradient-20);}.cls-135{fill:url(#linear-gradient-21);}.cls-136{fill:url(#linear-gradient-23);}.cls-137{fill:url(#linear-gradient-15);}.cls-138{fill:url(#linear-gradient-19);}.cls-139{fill:url(#linear-gradient-16);}.cls-140{fill:url(#linear-gradient-17);}.cls-141{fill:url(#linear-gradient-13);}.cls-142{fill:url(#linear-gradient-12);}.cls-143{fill:url(#linear-gradient-10);}.cls-144{fill:url(#linear-gradient-11);}.cls-145{fill:url(#linear-gradient-27);}.cls-146{fill:url(#linear-gradient-24);}.cls-147{fill:url(#linear-gradient-26);}.cls-148{fill:url(#linear-gradient-25);}.cls-149{fill:url(#linear-gradient-28);}.cls-150{fill:url(#linear-gradient-29);}.cls-151{fill:url(#linear-gradient-30);}.cls-152{fill:url(#linear-gradient-32);}.cls-153{fill:url(#linear-gradient-31);}.cls-154{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_4-2);}.cls-155{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_200);}.cls-156{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_206);}.cls-157{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_119);}.cls-158{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_118);}.cls-159{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_116);}.cls-160{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_117);}.cls-161{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_148);}.cls-162{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_162);}.cls-163{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_166);}.cls-164{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_158);}.cls-165{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_134);}.cls-166{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_150);}.cls-167{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_157);}.cls-168{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_140);}.cls-169{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_173);}.cls-170{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_176);}.cls-171{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_182);}.cls-172{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_4);}.cls-173{fill:#354144;opacity:.4;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m608,390.35c-115.23,101.81-372.78,131.89-529.48,22.58C-63.5,313.86-5.43,16.62,192.87,48.86c186.59,30.33,270.64-57.67,379.63,1.06,136.34,73.46,139.1,248.9,35.5,340.43Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 341.78,
    y1: 275.21,
    x2: 341.78,
    y2: 1.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f4e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#bcd6e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#7bb3ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62a6ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -9,
    y1: 387.9,
    x2: 679.56,
    y2: 387.9,
    gradientTransform: "translate(670.56 775.8) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#90c1eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#86bbeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#6babed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64a7ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 246.96,
    y1: 338.59,
    x2: 246.96,
    y2: 283.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f4e7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76b0ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_140",
    x1: -9,
    y1: 282.98,
    x2: 679.56,
    y2: 282.98,
    gradientTransform: "translate(670.56 565.96) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#241f22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f5160"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -9,
    y1: 286.41,
    x2: 679.56,
    y2: 286.41,
    gradientTransform: "translate(670.56 572.81) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#241f22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a3640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 275.59,
    y1: 158.21,
    x2: 683.87,
    y2: 88.72,
    gradientTransform: "translate(8.72 -35.35) rotate(4.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f1ea",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#edeeea",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#cee4ee",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#baddf0",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3dbf1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 242.02,
    y1: 110.13,
    x2: 427.74,
    y2: 101.72,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_31",
    x1: 626.02,
    y1: 251.91,
    x2: 626.02,
    y2: 222.83,
    gradientTransform: "translate(1137.43) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c64621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#c14520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#b54320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#a13f1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#853a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843a1d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_176",
    x1: 39.95,
    y1: 197.16,
    x2: 39.95,
    y2: 187.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#237b87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4aa4ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_182",
    x1: 39.95,
    y1: 187.09,
    x2: 39.95,
    y2: 169.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40909b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60afb6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_182-2",
    x1: 36.97,
    y1: 197.2,
    x2: 36.97,
    y2: 189.61,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_182"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_200",
    x1: 31.45,
    y1: 279.03,
    x2: 31.45,
    y2: 197.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#334452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#217481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4aa4ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_148",
    x1: 41.82,
    y1: 279.03,
    x2: 41.82,
    y2: 197.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a6172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4aa4ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38",
    x1: 79.8,
    y1: 184.07,
    x2: 79.8,
    y2: 144.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f25b0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f25b0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f4732e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f6854a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f7935e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f89b6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f99e6f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63",
    x1: 75.25,
    y1: 184.07,
    x2: 75.25,
    y2: 156.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8d3c1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#b14715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#cd5010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#e1560c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ed590a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f25b0a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63-2",
    x1: 84.34,
    x2: 84.34,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_55",
    x1: 75.79,
    y1: 144.03,
    x2: 75.79,
    y2: 78.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f25b0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#f25f11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f36c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#f68144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f99e6f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_55-2",
    x1: 83.8,
    x2: 83.8,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38-2",
    x1: 79.8,
    y1: 144.03,
    x2: 79.8,
    y2: 78.19,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38-3",
    x1: 79.8,
    y1: 144.03,
    x2: 79.8,
    y2: 78.19,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_55-3",
    x1: 69.26,
    x2: 69.26,
    y2: 138.97,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63-3",
    x1: 69.26,
    y1: 138.97,
    x2: 69.26,
    y2: 126.14,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_55-4",
    x1: 196.75,
    y1: 144.03,
    x2: 196.75,
    y2: 138.97,
    gradientTransform: "translate(-106.41 283) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63-4",
    x1: 196.75,
    y1: 138.97,
    x2: 196.75,
    y2: 126.14,
    gradientTransform: "translate(287.08) rotate(-180) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63-5",
    x1: 79.8,
    y1: 144.03,
    x2: 79.8,
    y2: 128.28,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38-4",
    x1: 210.15,
    y1: 184.07,
    x2: 210.15,
    y2: 144.03,
    gradientTransform: "translate(-76.31 328.1) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63-6",
    x1: 205.61,
    y1: 184.07,
    x2: 205.61,
    y2: 156.77,
    gradientTransform: "translate(344) rotate(-180) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63-7",
    x1: 214.69,
    y1: 184.07,
    x2: 214.69,
    y2: 156.77,
    gradientTransform: "translate(344) rotate(-180) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_55-5",
    x1: 206.15,
    y1: 144.03,
    x2: 206.15,
    y2: 78.19,
    gradientTransform: "translate(344) rotate(-180) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_55-6",
    x1: 214.16,
    y1: 144.03,
    x2: 214.16,
    y2: 78.19,
    gradientTransform: "translate(344) rotate(-180) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38-5",
    x1: 210.15,
    y1: 144.03,
    x2: 210.15,
    y2: 78.19,
    gradientTransform: "translate(344) rotate(-180) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38-6",
    x1: 210.15,
    y1: 144.03,
    x2: 210.15,
    y2: 78.19,
    gradientTransform: "translate(344) rotate(-180) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_55-7",
    x1: 199.61,
    y1: 144.03,
    x2: 199.61,
    y2: 138.97,
    gradientTransform: "translate(-55.23 283) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63-8",
    x1: 199.61,
    y1: 138.97,
    x2: 199.61,
    y2: 126.14,
    gradientTransform: "translate(344) rotate(-180) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_55-8",
    x1: 66.39,
    x2: 66.39,
    y2: 138.97,
    gradientTransform: "translate(56.92)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63-9",
    x1: 66.39,
    y1: 138.97,
    x2: 66.39,
    y2: 126.14,
    gradientTransform: "translate(56.92)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63-10",
    x1: 210.15,
    y1: 144.03,
    x2: 210.15,
    y2: 128.28,
    gradientTransform: "translate(344) rotate(-180) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38-7",
    x1: 106.82,
    y1: 279.03,
    x2: 106.82,
    y2: 184.07,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_54",
    x1: 81.83,
    y1: 266.45,
    x2: 81.83,
    y2: 244.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f25b0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f25f10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#f4722d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#f68245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#f78e58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f89765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#f89c6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f99e6f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63-11",
    x1: 81.83,
    y1: 266.45,
    x2: 81.83,
    y2: 251.61,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_54-2",
    x1: 212.18,
    y1: 266.45,
    x2: 212.18,
    y2: 244.07,
    gradientTransform: "translate(344) rotate(-180) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63-12",
    x1: 131.81,
    y1: 266.45,
    x2: 131.81,
    y2: 251.61,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_67",
    x1: 64.73,
    y1: 279.03,
    x2: 64.73,
    y2: 264.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e1415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b4957"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_67-2",
    x1: 148.91,
    x2: 148.91,
    gradientTransform: "translate(297.83 543.81) rotate(-180)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_67"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_49",
    x1: 106.82,
    y1: 274.04,
    x2: 106.82,
    y2: 271.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#332628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843a1d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_50",
    x1: 106.82,
    y1: 271.19,
    x2: 106.82,
    y2: 266.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e1415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455c6e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_48",
    x1: 84.97,
    y1: 271.19,
    x2: 84.97,
    y2: 255.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#332628"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_48-2",
    x1: 128.67,
    x2: 128.67,
    gradientTransform: "translate(257.33 526.72) rotate(-180)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_74",
    x1: 62.39,
    y1: 264.78,
    x2: 62.39,
    y2: 170.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c2d34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455c6e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_74-2",
    x1: 151.25,
    x2: 151.25,
    y2: 170.3,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63-13",
    x1: 106.82,
    y1: 214.75,
    x2: 106.82,
    y2: 193.86,
    gradientTransform: "translate(224.46 6.03) rotate(58.28)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_54-3",
    x1: 106.82,
    x2: 106.82,
    y2: 228.54,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_54-4",
    x1: 106.82,
    y1: 184.07,
    x2: 106.82,
    y2: 165.12,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38-8",
    x1: 81.83,
    y1: 210.26,
    x2: 81.83,
    y2: 196.87,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38-9",
    x1: 212.18,
    y1: 210.26,
    x2: 212.18,
    y2: 196.87,
    gradientTransform: "translate(344) rotate(-180) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63-14",
    x1: 106.82,
    y1: 266.45,
    x2: 106.82,
    y2: 240.97,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_49-2",
    x1: 104.34,
    y1: 266.45,
    x2: 104.34,
    y2: 246.48,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_49-3",
    x1: 109.3,
    y1: 266.45,
    x2: 109.3,
    y2: 246.48,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38-10",
    x1: 66.73,
    y1: 170.3,
    x2: 66.73,
    y2: 151.43,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_74-3",
    x1: 66.73,
    y1: 170.3,
    x2: 66.73,
    y2: 151.43,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38-11",
    x1: 197.08,
    y1: 170.3,
    x2: 197.08,
    y2: 151.43,
    gradientTransform: "translate(344) rotate(-180) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_74-4",
    x1: 146.91,
    y1: 170.3,
    x2: 146.91,
    y2: 151.43,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_140-2",
    x1: 982.17,
    y1: 279.03,
    x2: 982.17,
    y2: 233.5,
    gradientTransform: "translate(-826.91 512.53) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_148-2",
    x1: 971.49,
    y1: 279.03,
    x2: 971.49,
    y2: 244.86,
    gradientTransform: "translate(-805.55 523.89) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_148"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_140-3",
    x1: 32.14,
    y1: 279.03,
    x2: 32.14,
    y2: 257.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_93",
    x1: 927.19,
    y1: 273.21,
    x2: 927.19,
    y2: 214.75,
    gradientTransform: "translate(1137.43) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c2d34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2d2f37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#313741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#394552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#425667"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_74-5",
    x1: 927.19,
    y1: 273.21,
    x2: 927.19,
    y2: 228.14,
    gradientTransform: "translate(1137.43) rotate(-180) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_74-6",
    x1: 920.4,
    y1: 213.92,
    x2: 934,
    y2: 213.92,
    gradientTransform: "translate(-716.97 427.85) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_94",
    x1: 927.19,
    y1: 279.03,
    x2: 927.19,
    y2: 275.95,
    gradientTransform: "translate(-716.94 554.98) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#455c6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c2d34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_117",
    x1: 202.64,
    y1: 44.2,
    x2: 223.35,
    y2: 44.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f99e6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#f46f28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f25b0a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_117-2",
    y1: 32.67,
    y2: 32.67,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_117"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_116",
    x1: 1867.11,
    y1: -2434.31,
    x2: 1867.11,
    y2: -2452.69,
    gradientTransform: "translate(-1654.11 2713.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e5361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1415"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_118",
    x1: 195,
    y1: 64.62,
    x2: 230.99,
    y2: 64.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca774f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a75936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8d4223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843a1d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_119",
    x1: 192.87,
    y1: 73.43,
    x2: 233.12,
    y2: 73.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f99e6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#f89c6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f89765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#f78e58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#f68245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#f4722d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#f25f10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f25b0a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_119-2",
    x1: 192.87,
    y1: 61.65,
    x2: 233.12,
    y2: 61.65,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_119"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_118-2",
    x1: 195.91,
    y1: 70.54,
    x2: 230.08,
    y2: 70.54,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_118"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_119-3",
    x1: 192.87,
    y1: 67.58,
    x2: 233.12,
    y2: 67.58,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_119"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_118-3",
    x1: 193.19,
    y1: 52.76,
    x2: 232.8,
    y2: 52.76,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_118"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_119-4",
    x1: 192.87,
    y1: 55.73,
    x2: 233.12,
    y2: 55.73,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_119"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_119-5",
    x1: 192.87,
    y1: 49.92,
    x2: 233.12,
    y2: 49.92,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_119"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_118-4",
    x1: 194.1,
    y1: 58.69,
    x2: 231.89,
    y2: 58.69,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_118"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_27",
    x1: 606.98,
    y1: 254.49,
    x2: 606.98,
    y2: 227.12,
    gradientTransform: "translate(1137.43) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f25b0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#f57735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#f7935f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f99e6f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_27-2",
    x1: 787.22,
    y1: 234.58,
    x2: 787.22,
    y2: 205.62,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_206",
    x1: 1054.33,
    y1: 275.07,
    x2: 1054.33,
    y2: 267.16,
    gradientTransform: "translate(-602.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#455c6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d3138"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_27-3",
    x1: 751.7,
    y1: 241.17,
    x2: 751.7,
    y2: 191.43,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_23",
    x1: 968.4,
    y1: 256.24,
    x2: 998.62,
    y2: 256.24,
    gradientTransform: "translate(-602.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#455c6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#355d6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#0b6071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a6172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_4",
    x1: 921.39,
    y1: 235.66,
    x2: 960.64,
    y2: 274.91,
    gradientTransform: "translate(-602.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4aa4ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a6172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_22",
    x1: 1149.13,
    y1: 261.38,
    x2: 1229.93,
    y2: 261.38,
    gradientTransform: "translate(-602.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4aa4ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0a6172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455c6e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_4-2",
    x1: 998.62,
    y1: 258.61,
    x2: 1149.13,
    y2: 258.61,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_10",
    x1: 925.23,
    y1: 267.16,
    x2: 925.23,
    y2: 255.37,
    gradientTransform: "translate(-602.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e1415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a6172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_31-2",
    x1: 549.25,
    y1: 241.79,
    x2: 586.61,
    y2: 241.79,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_27-4",
    x1: 695.74,
    y1: 241.48,
    x2: 695.74,
    y2: 212.4,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_27-5",
    x1: 669.16,
    y1: 241.48,
    x2: 669.16,
    y2: 212.4,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_158",
    x1: 501.85,
    y1: 279.03,
    x2: 501.85,
    y2: 167.45,
    gradientTransform: "translate(1137.43) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#4aa4ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96c9ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_157",
    x1: 512.76,
    y1: 279.03,
    x2: 512.76,
    y2: 208.45,
    gradientTransform: "translate(111.92 487.47) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a6172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#4aa4ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60afb6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_150",
    x1: 499.69,
    y1: 279.03,
    x2: 499.69,
    y2: 193.16,
    gradientTransform: "translate(1137.43) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a6172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4aa4ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_148-3",
    x1: 490.82,
    y1: 279.03,
    x2: 490.82,
    y2: 182.97,
    gradientTransform: "translate(1137.43) rotate(-180) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_148"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_162",
    x1: 491.32,
    y1: 279.03,
    x2: 491.32,
    y2: 247.14,
    gradientTransform: "translate(154.79 526.17) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f99e6f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_166",
    x1: 469.96,
    y1: 279.03,
    x2: 469.96,
    y2: 253.47,
    gradientTransform: "translate(197.51 532.5) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c64621"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_166-2",
    x1: 477.08,
    x2: 477.08,
    gradientTransform: "translate(183.27 532.5) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_166"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_166-3",
    x1: 484.2,
    x2: 484.2,
    gradientTransform: "translate(169.03 532.5) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_166"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_166-4",
    x1: 491.32,
    x2: 491.32,
    gradientTransform: "translate(154.79 532.5) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_166"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_166-5",
    x1: 498.44,
    y1: 279.03,
    x2: 498.44,
    y2: 253.47,
    gradientTransform: "translate(140.55 532.5) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_166"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_166-6",
    x1: 505.56,
    y1: 279.03,
    x2: 505.56,
    y2: 253.47,
    gradientTransform: "translate(126.32 532.5) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_166"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_166-7",
    x1: 512.68,
    y1: 279.03,
    x2: 512.68,
    y2: 253.47,
    gradientTransform: "translate(112.08 532.5) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_166"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_173",
    x1: 488.53,
    y1: 247.18,
    x2: 488.53,
    y2: 242.02,
    gradientTransform: "translate(160.38 489.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a55835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d17d54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_140-4",
    x1: 518.45,
    y1: 279.03,
    x2: 518.45,
    y2: 222.84,
    gradientTransform: "translate(100.54 501.87) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_134",
    x1: 518.44,
    y1: 222.84,
    x2: 518.44,
    y2: 216.92,
    gradientTransform: "translate(100.54 439.76) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f343c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a4956"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_162-2",
    x1: 1110.54,
    y1: 279.03,
    x2: 1110.54,
    y2: 226.28,
    gradientTransform: "translate(1166.58) rotate(-180) scale(1 -1)",
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_162"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 556.01,
    y1: 227.36,
    x2: 600.82,
    y2: 227.36,
    gradientTransform: "translate(700.13) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#a6afb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#8c9698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#4b5759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354144"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 445.87,
    y1: 215.56,
    x2: 445.87,
    y2: 223.73,
    gradientTransform: "translate(700.13) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#dbdeda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#c1c6c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fa7a4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 237.01,
    y1: 259.76,
    x2: 238.23,
    y2: 261.98,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 549.29,
    y1: 373.39,
    x2: 544.62,
    y2: 292.44,
    gradientTransform: "translate(700.13) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#d3d6d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fa7a4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 376.32,
    y1: 378.89,
    x2: 371.86,
    y2: 301.66,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 137.11,
    y1: 330.87,
    x2: 248.75,
    y2: 330.87,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 378.87,
    y1: 295.53,
    x2: 378.14,
    y2: 282.14,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 365.26,
    y1: 330.88,
    x2: 367.17,
    y2: 330.88,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 155.83,
    y1: 323.74,
    x2: 150.3,
    y2: 362.81,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 114.6,
    y1: 348.74,
    x2: 133.23,
    y2: 348.74,
    gradientTransform: "translate(700.13) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#a6afb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#abb4b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#c5cdca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 140.01,
    y1: 298.02,
    x2: 166.37,
    y2: 312.69,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 374.94,
    y1: 369.74,
    x2: 373.75,
    y2: 350.14,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 528.24,
    y1: 372.33,
    x2: 528.24,
    y2: 320.26,
    gradientTransform: "translate(700.13) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#c5cdca",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c0c8c6",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#b5bdbd",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#a6afb1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 372.32,
    y1: 377.25,
    x2: 371.36,
    y2: 360.08,
    gradientTransform: "translate(700.13) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#677071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#808888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9fa7a4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 194.46,
    y1: 374.17,
    x2: 194.46,
    y2: 322.1,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 341.74,
    y1: 298.99,
    x2: 353.49,
    y2: 298.99,
    gradientTransform: "translate(667.48 632.16) rotate(-92.62) scale(1 -1)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 334.79,
    y1: 298.77,
    x2: 361.35,
    y2: 298.77,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 377.68,
    y1: 297.57,
    x2: 389.43,
    y2: 297.57,
    gradientTransform: "translate(631.23 666.48) rotate(-92.62) scale(1 -1)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 370.73,
    y1: 297.35,
    x2: 397.29,
    y2: 297.35,
    gradientTransform: "translate(703.46 4.81) rotate(-179.25) scale(1 -1)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 266.42,
    y1: 281.81,
    x2: 261.98,
    y2: 282.33,
    gradientTransform: "translate(700.13) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afb3af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#959a97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727876"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 269.93,
    y1: 280.15,
    x2: 263.71,
    y2: 280.88,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 270.18,
    y1: 271.07,
    x2: 256.81,
    y2: 272.65,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 269,
    y1: 276.24,
    x2: 270.98,
    y2: 263.24,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 273.68,
    y1: 274.34,
    x2: 267.79,
    y2: 274.34,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 255.52,
    y1: 281.94,
    x2: 275.04,
    y2: 275.49,
    gradientTransform: "translate(700.13) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afb3af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#9fa7a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757a78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 567.34,
    y1: 251.18,
    x2: 622.13,
    y2: 251.18,
    gradientTransform: "translate(700.13) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#12140d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#222826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354144"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m651.98,413.34c-134.27,118.63-434.37,153.67-616.96,26.3C-130.45,324.22-50.78-43.44,180.28-5.88c217.41,35.35,302.21-53.64,429.21,14.79,158.86,85.59,163.21,297.78,42.49,404.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: -9,
    y: 283.54,
    width: 688.56,
    height: 208.73,
    transform: "translate(670.56 775.8) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m105.28,283.98c-143.17,0,127.9,10.91,53.2,11.89-256.03,3.34,31.78,4.06-230.54,12.4-131.41,4.18,359.77,11.53,54.59,12.71-66.82.26-229.55,2.83-226.94,15.2,52.05,0,965.74,2.41,892.12,2.41,107.77,0,126.87-33.17,16.85-33.17s-216.93-8.71-161.27-8.71c313.8,0,141.19-6.93,63.35-6.93-104.87,0-367.14-4.03-270.11-4.03,47.11,0,4.48-1.78-33.09-1.78H105.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: -9,
    y: 279.09,
    width: 688.56,
    height: 7.78,
    transform: "translate(670.56 565.96) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: -9,
    y: 285.94,
    width: 688.56,
    height: 0.93,
    transform: "translate(670.56 572.81) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: -9,
    y: 327.18,
    width: 688.56,
    height: 208.73,
    transform: "translate(670.56 863.09) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m474.01,454.09c-156.55-53.55-401.02-10.15-284.52-7.43,116.5,2.72,170.79,14.69-33.74,35.11-204.53,20.42,444.85,27.68,318.26-27.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "m237.76,145.54c35.6-19.53,77.82,2.6,104.75-13.04,26.93-15.65,109.69-.43,103.27-26.65-6.42-26.22,50.83-8.33,75.11-22.49,24.28-14.16,73.11-7.46,102.01.66,7.95,2.23,17.63,3.48,27.49,4.12,32.38,2.1,59.88,24.46,68.11,55.85l.14.52s-463.17,1.13-480.87,1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "m158.06,102.59c6.15-7.72,70.72-1.82,93.42-12.16,36.12-16.46,54.19-4.47,83.06,3.14,28.87,7.62,59.21-3.82,69.22,1.88,10.01,5.7,11.29,8.16,11.29,8.16l-257-1.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "501.79 222.83 498.86 251.91 523.97 251.91 501.79 222.83"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 30.04,
    y: 187.09,
    width: 19.83,
    height: 10.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 39.42,
    y: 169.5,
    width: 1.06,
    height: 17.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 26.55,
    y: 189.61,
    width: 20.84,
    height: 7.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "m25.09,197.16v81.87h12.71c-.29-44.55-3.18-68.51-6.14-81.87h-6.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "m51.98,197.16h-20.32c2.96,13.36,5.85,37.32,6.14,81.87h14.18v-81.87Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 66.73,
    y: 144.03,
    width: 26.14,
    height: 40.04
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 64,
    y: 146.84,
    width: 31.6,
    height: 2.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 66.73,
    y: 149.59,
    width: 26.14,
    height: 1.84
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "79.8 165.23 75.25 156.77 70.71 165.23 70.71 184.07 79.8 184.07 79.8 165.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "88.88 165.23 84.34 156.77 79.8 165.23 79.8 184.07 88.88 184.07 88.88 165.23"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "71.79 144.03 75.15 144.03 79.8 78.19 71.79 144.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "79.8 78.19 84.44 144.03 87.8 144.03 79.8 78.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "75.15 144.03 84.44 144.03 79.8 78.19 75.15 144.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "75.15 144.03 84.44 144.03 79.8 78.19 75.15 144.03"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 66.73,
    y: 138.97,
    width: 5.06,
    height: 5.06
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "69.26 126.14 66.73 138.97 71.79 138.97 69.26 126.14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 87.8,
    y: 138.97,
    width: 5.06,
    height: 5.06,
    transform: "translate(180.67 283) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "90.33 126.14 92.86 138.97 87.8 138.97 90.33 126.14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 74.07,
    y: 122.05,
    width: 11.44,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 77.25,
    y: 98.55,
    width: 5.08,
    height: 1.06
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "83.18 133.16 79.8 128.28 76.41 133.16 76.41 144.03 83.18 144.03 83.18 133.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 120.77,
    y: 144.03,
    width: 26.14,
    height: 40.04,
    transform: "translate(267.69 328.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 118.04,
    y: 146.84,
    width: 31.6,
    height: 2.75,
    transform: "translate(267.69 296.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 120.77,
    y: 149.59,
    width: 26.14,
    height: 1.84,
    transform: "translate(267.69 301.01) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "133.84 165.23 138.38 156.77 142.93 165.23 142.93 184.07 133.84 184.07 133.84 165.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "124.76 165.23 129.3 156.77 133.84 165.23 133.84 184.07 124.76 184.07 124.76 165.23"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "141.85 144.03 138.48 144.03 133.84 78.19 141.85 144.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "133.84 78.19 129.2 144.03 125.83 144.03 133.84 78.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "138.48 144.03 129.2 144.03 133.84 78.19 138.48 144.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "138.48 144.03 129.2 144.03 133.84 78.19 138.48 144.03"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 141.85,
    y: 138.97,
    width: 5.06,
    height: 5.06,
    transform: "translate(288.76 283) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "144.38 126.14 146.91 138.97 141.85 138.97 144.38 126.14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 120.77,
    y: 138.97,
    width: 5.06,
    height: 5.06
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "123.3 126.14 120.77 138.97 125.83 138.97 123.3 126.14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 128.12,
    y: 122.05,
    width: 11.44,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 131.3,
    y: 98.55,
    width: 5.08,
    height: 1.06
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "130.46 133.16 133.84 128.28 137.23 133.16 137.23 144.03 130.46 144.03 130.46 133.16"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 66.73,
    y: 184.07,
    width: 80.18,
    height: 94.96
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "89.08 255.26 81.83 244.07 74.57 255.26 72.45 255.26 72.45 266.45 74.57 266.45 89.08 266.45 91.2 266.45 91.2 255.26 89.08 255.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m81.83,251.61s-5.93,3.03-5.93,7.92v6.91h11.86v-6.91c0-4.89-5.93-7.92-5.93-7.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "124.56 255.26 131.81 244.07 139.07 255.26 141.19 255.26 141.19 266.45 139.07 266.45 124.56 266.45 122.44 266.45 122.44 255.26 124.56 255.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m131.81,251.61s5.93,3.03,5.93,7.92v6.91h-11.86v-6.91c0-4.89,5.93-7.92,5.93-7.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 46.81,
    y: 264.78,
    width: 35.83,
    height: 14.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 131,
    y: 264.78,
    width: 35.83,
    height: 14.24,
    transform: "translate(297.83 543.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "144.14 274.04 69.5 274.04 58.1 279.03 155.54 279.03 144.14 274.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "131 271.19 82.64 271.19 76.13 274.04 137.51 274.04 131 271.19"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 87.3,
    y: 266.45,
    width: 39.04,
    height: 4.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 82.64,
    y: 255.53,
    width: 4.66,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 126.34,
    y: 255.53,
    width: 4.66,
    height: 15.67,
    transform: "translate(257.33 526.72) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 66.73,
    y: 184.07,
    width: 80.18,
    height: 4.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 72.45,
    y: 224.55,
    width: 68.74,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 72.45,
    y: 188.34,
    width: 68.74,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 66.73,
    y: 220.27,
    width: 80.18,
    height: 4.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 91.2,
    y: 184.07,
    width: 3.32,
    height: 82.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 119.11,
    y: 184.07,
    width: 3.32,
    height: 82.38,
    transform: "translate(241.55 450.52) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 61.01,
    y: 170.3,
    width: 2.77,
    height: 94.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 69.68,
    y: 170.3,
    width: 2.77,
    height: 94.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 63.78,
    y: 170.3,
    width: 5.9,
    height: 94.48
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 149.86,
    y: 170.3,
    width: 2.77,
    height: 94.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 141.19,
    y: 170.3,
    width: 2.77,
    height: 94.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 143.96,
    y: 170.3,
    width: 5.9,
    height: 94.48
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 106.82,
    cy: 204.31,
    r: 10.45,
    transform: "translate(-123.13 187.76) rotate(-58.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m108.06,196.83c0-.68-.55-1.24-1.24-1.24s-1.24.55-1.24,1.24,1.24,5.99,1.24,5.99c0,0,1.24-5.31,1.24-5.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m104.15,197.21c-.34-.59-1.1-.8-1.69-.45-.59.34-.8,1.1-.45,1.69.34.59,4.07,4.57,4.07,4.57,0,0-1.58-5.22-1.92-5.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m100.96,199.5c-.59-.34-1.35-.14-1.69.45-.34.59-.14,1.35.45,1.69.59.34,5.81,1.92,5.81,1.92,0,0-3.98-3.73-4.57-4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m99.34,203.07c-.68,0-1.24.55-1.24,1.24s.55,1.24,1.24,1.24,5.99-1.24,5.99-1.24c0,0-5.31-1.24-5.99-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m99.72,206.97c-.59.34-.8,1.1-.45,1.69.34.59,1.1.8,1.69.45.59-.34,4.57-4.07,4.57-4.07,0,0-5.22,1.58-5.81,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m102.01,210.16c-.34.59-.14,1.35.45,1.69.59.34,1.35.14,1.69-.45s1.92-5.81,1.92-5.81c0,0-3.73,3.98-4.07,4.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m105.58,211.79c0,.68.55,1.24,1.24,1.24s1.24-.55,1.24-1.24-1.24-5.99-1.24-5.99c0,0-1.24,5.31-1.24,5.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m109.49,211.4c.34.59,1.1.8,1.69.45.59-.34.8-1.1.45-1.69-.34-.59-4.07-4.57-4.07-4.57,0,0,1.58,5.22,1.92,5.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m112.68,209.12c.59.34,1.35.14,1.69-.45.34-.59.14-1.35-.45-1.69-.59-.34-5.81-1.92-5.81-1.92,0,0,3.98,3.73,4.57,4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m114.3,205.55c.68,0,1.24-.55,1.24-1.24s-.55-1.24-1.24-1.24-5.99,1.24-5.99,1.24c0,0,5.31,1.24,5.99,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m113.91,201.64c.59-.34.8-1.1.45-1.69-.34-.59-1.1-.8-1.69-.45s-4.57,4.07-4.57,4.07c0,0,5.22-1.58,5.81-1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m111.63,198.45c.34-.59.14-1.35-.45-1.69-.59-.34-1.35-.14-1.69.45s-1.92,5.81-1.92,5.81c0,0,3.73-3.98,4.07-4.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 61.01,
    y: 224.02,
    width: 11.44,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 61.01,
    y: 198.68,
    width: 11.44,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 61.01,
    y: 187.81,
    width: 11.44,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 61.01,
    y: 183.54,
    width: 11.44,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 61.01,
    y: 252.38,
    width: 11.44,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 61.01,
    y: 233.16,
    width: 11.44,
    height: 1.06
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 91.2,
    y: 233.16,
    width: 3.32,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 91.2,
    y: 234.82,
    width: 3.32,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 91.2,
    y: 236.48,
    width: 3.32,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 91.2,
    y: 238.14,
    width: 3.32,
    height: 1.06
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 119.11,
    y: 233.16,
    width: 3.32,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 119.11,
    y: 234.82,
    width: 3.32,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 119.11,
    y: 236.48,
    width: 3.32,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 119.11,
    y: 238.14,
    width: 3.32,
    height: 1.06
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 61.01,
    y: 219.74,
    width: 11.44,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 141.19,
    y: 224.02,
    width: 11.44,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 141.19,
    y: 198.68,
    width: 11.44,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 141.19,
    y: 187.81,
    width: 11.44,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 141.19,
    y: 183.54,
    width: 11.44,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 141.19,
    y: 252.38,
    width: 11.44,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 141.19,
    y: 233.16,
    width: 11.44,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 141.19,
    y: 219.74,
    width: 11.44,
    height: 1.06
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "119.11 247.49 106.82 228.54 94.53 247.49 94.53 266.45 119.11 266.45 119.11 247.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "119.11 184.07 106.82 165.12 94.53 184.07 119.11 184.07"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m81.83,196.87h0c-1.29,0-2.33,1.05-2.33,2.33v11.06h4.67v-11.06c0-1.29-1.05-2.33-2.33-2.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 78.07,
    y: 210.26,
    width: 7.52,
    height: 1.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 81.3,
    y: 196.87,
    width: 1.06,
    height: 13.39
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m131.81,196.87h0c1.29,0,2.33,1.05,2.33,2.33v11.06h-4.67v-11.06c0-1.29,1.05-2.33,2.33-2.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 128.05,
    y: 210.26,
    width: 7.52,
    height: 1.43,
    transform: "translate(263.63 421.95) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 131.28,
    y: 196.87,
    width: 1.06,
    height: 13.39
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m106.82,240.97s-10.18,5.21-10.18,13.61v11.87h20.36v-11.87c0-8.4-10.18-13.61-10.18-13.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m106.82,171.09s-5.19,2.65-5.19,6.93v6.05h10.37v-6.05c0-4.28-5.19-6.93-5.19-6.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m103.53,184.07v-6.05c0-2.03,1.93-3.79,3.29-4.71,1.36.93,3.29,2.69,3.29,4.71v6.05h-6.57Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 102.34,
    y: 254.57,
    width: 4.01,
    height: 11.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 107.29,
    y: 254.57,
    width: 4.01,
    height: 11.87
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m115.63,266.98h-17.62v-12.4c0-6.02,5.97-10.31,8.53-11.87l.28-.17.28.17c2.57,1.57,8.54,5.88,8.54,11.87v12.4Zm-16.56-1.06h15.5v-11.34c0-5.26-5.22-9.19-7.76-10.8-2.54,1.59-7.75,5.51-7.75,10.8v11.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m113.73,266.98h-13.83v-12.4c0-4.41,4.14-7.9,6.61-9.59l.3-.21.3.21c2.47,1.7,6.62,5.21,6.62,9.59v12.4Zm-12.77-1.06h11.71v-11.34c0-3.74-3.54-6.86-5.86-8.51-2.32,1.64-5.85,4.76-5.85,8.51v11.34Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "78.81 232.23 77.53 230.75 76.25 232.23 75.45 231.53 77.53 229.13 79.61 231.53 78.81 232.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m77.53,237.64c-1.22,0-2.21-.99-2.21-2.21h1.06c0,.64.52,1.15,1.15,1.15s1.15-.52,1.15-1.15h1.06c0,1.22-.99,2.21-2.21,2.21Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "84.84 232.23 84.04 231.53 86.12 229.13 88.2 231.53 87.4 232.23 86.12 230.75 84.84 232.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m86.12,237.64c-1.22,0-2.21-.99-2.21-2.21h1.06c0,.64.52,1.15,1.15,1.15s1.15-.52,1.15-1.15h1.06c0,1.22-.99,2.21-2.21,2.21Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "137.39 232.23 136.11 230.75 134.83 232.23 134.02 231.53 136.11 229.13 138.19 231.53 137.39 232.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m136.11,237.64c-1.22,0-2.21-.99-2.21-2.21h1.06c0,.64.52,1.15,1.15,1.15s1.15-.52,1.15-1.15h1.06c0,1.22-.99,2.21-2.21,2.21Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "126.24 232.23 125.43 231.53 127.52 229.13 129.6 231.53 128.8 232.23 127.52 230.75 126.24 232.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m127.52,237.64c-1.22,0-2.21-.99-2.21-2.21h1.06c0,.64.52,1.15,1.15,1.15s1.15-.52,1.15-1.15h1.06c0,1.22-.99,2.21-2.21,2.21Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "63.41 170.3 70.04 170.3 66.73 151.43 63.41 170.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "66.73 151.43 61.01 170.3 63.41 170.3 70.04 170.3 72.45 170.3 66.73 151.43"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "150.23 170.3 143.6 170.3 146.91 151.43 150.23 170.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "146.91 151.43 141.19 170.3 143.6 170.3 150.23 170.3 152.63 170.3 146.91 151.43"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m132.58,250.84c0,1.35,1.1,2.45,2.45,2.45h33.37s0,0,0,0h15.58s0,0,0,0h15.85c1.36,0,2.45-1.1,2.45-2.45s-1.1-2.45-2.45-2.45h-14.43c0-5.09-4.12-9.21-9.21-9.21-1.41,0-2.73.32-3.92.89-.04-1.72-1.44-3.1-3.17-3.1-.75,0-1.44.27-1.98.71-.59-4.51-4.45-8-9.12-8-5.09,0-9.21,4.12-9.21,9.21,0,.19.02.39.03.58-.71-.36-1.51-.58-2.36-.58-2.94,0-5.32,2.38-5.32,5.32,0,.13.03.26.04.39-.45-.24-.95-.39-1.49-.39-1.76,0-3.18,1.42-3.18,3.18,0,.35.07.68.18,1h-1.65c-1.36,0-2.45,1.1-2.45,2.45Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m202.29,252.91h-2.01c.13-.38.21-.79.21-1.22,0-2.14-1.74-3.88-3.88-3.88-.66,0-1.27.18-1.81.47.01-.16.05-.31.05-.47,0-3.58-2.91-6.49-6.49-6.49-1.04,0-2.01.27-2.88.7.01-.23.04-.47.04-.7,0-6.2-5.03-11.23-11.23-11.23-5.7,0-10.4,4.25-11.12,9.75-.67-.54-1.5-.87-2.42-.87-2.11,0-3.82,1.69-3.87,3.78-1.45-.69-3.07-1.08-4.78-1.08-6.2,0-11.23,5.03-11.23,11.23h-17.6c-1.65,0-2.99,1.34-2.99,2.99s1.34,2.99,2.99,2.99h19.33s0,0,0,0h19s0,0,0,0h40.7c1.65,0,2.99-1.34,2.99-2.99s-1.34-2.99-2.99-2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m193.53,267.31h-2.01c.13-.38.21-.79.21-1.22,0-2.14-1.74-3.88-3.88-3.88-.66,0-1.27.18-1.81.47.01-.16.05-.31.05-.47,0-3.58-2.91-6.49-6.49-6.49-1.04,0-2.01.27-2.88.7.01-.23.04-.47.04-.7,0-6.2-5.03-11.23-11.23-11.23-5.7,0-10.4,4.25-11.12,9.75-.67-.54-1.5-.87-2.42-.87-2.11,0-3.82,1.69-3.87,3.78-1.45-.69-3.07-1.08-4.78-1.08-6.2,0-11.23,5.03-11.23,11.23h-17.6c-1.65,0-2.99,1.34-2.99,2.99s1.34,2.99,2.99,2.99h19.33s0,0,0,0h19s0,0,0,0h40.7c1.65,0,2.99-1.34,2.99-2.99s-1.34-2.99-2.99-2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m235.07,231.83h-19.05c0-3.58-2.9-6.49-6.49-6.49-.9,0-1.76.19-2.54.52.24-.95.38-1.94.38-2.96,0-6.72-5.45-12.17-12.17-12.17s-12.17,5.45-12.17,12.17c0,.38.02.76.06,1.14-.13,0-.26-.04-.39-.04-4.32,0-7.83,3.5-7.83,7.83h-3.57c-1.79,0-3.24,1.45-3.24,3.24s1.45,3.24,3.24,3.24h7.02s0,0,0,0h8.76s0,0,0,0h47.99c1.79,0,3.24-1.45,3.24-3.24s-1.45-3.24-3.24-3.24Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 144.58,
    y: 233.5,
    width: 21.36,
    height: 45.53,
    transform: "translate(310.52 512.53) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 156.7,
    y: 244.86,
    width: 18.49,
    height: 34.16,
    transform: "translate(331.88 523.89) rotate(-180)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "49.86 257.77 14.41 264.31 14.41 279.03 49.86 279.03 49.86 257.77"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 143.5,
    y: 260.71,
    width: 58.5,
    height: 3.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 190.7,
    y: 251.37,
    width: 1.06,
    height: 10.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 181.1,
    y: 251.37,
    width: 1.06,
    height: 10.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 171.5,
    y: 251.37,
    width: 1.06,
    height: 10.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 161.89,
    y: 251.37,
    width: 1.06,
    height: 10.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 152.29,
    y: 251.37,
    width: 1.06,
    height: 10.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 195.29,
    y: 249.71,
    width: 1.06,
    height: 14.27,
    transform: "translate(-119.29 186) rotate(-40.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 185.9,
    y: 249.56,
    width: 1.06,
    height: 14.55,
    transform: "translate(-123.12 186.83) rotate(-41.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 176.3,
    y: 249.56,
    width: 1.06,
    height: 14.55,
    transform: "translate(-125.5 180.47) rotate(-41.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 166.69,
    y: 249.56,
    width: 1.06,
    height: 14.55,
    transform: "translate(-127.88 174.13) rotate(-41.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 157.09,
    y: 249.56,
    width: 1.06,
    height: 14.55,
    transform: "translate(-130.27 167.8) rotate(-41.28)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m145.2,255.63c127.37-6.6,225.54-7.45,296.84-7.45v-4.24c-71.35,0-169.6.85-297.06,7.45l.22,4.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "206.84 240 207.65 240 207.85 229.81 206.99 229.81 206.99 228.14 207.88 228.14 209.23 228.14 209.34 219.08 209.4 214.75 210.23 214.75 210.23 213.09 223.83 213.09 223.83 214.75 224.7 214.75 224.76 219.08 224.87 228.14 226.22 228.14 227.08 228.14 227.08 229.81 226.25 229.81 226.45 240 227.23 240 227.23 241.66 226.48 241.66 227.11 273.21 227.11 279.03 225.22 279.03 208.88 279.03 206.99 279.03 206.99 273.21 207.61 241.66 206.84 241.66 206.84 240"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m219.11,278.78l1.08-1.17c42.5-46.28,98.1-69.75,165.24-69.75h1.59s0-3.18,0-3.18h-1.59c-30.3,0-58.45,4.68-83.67,13.91-31.67,11.59-59.9,30.72-83.91,56.87l-1.08,1.17,2.34,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m218.42,240.2l1.38-.79c34.2-19.6,90.7-42.97,165.62-42.97h1.59s0-3.18,0-3.18h-1.59c-75.62,0-132.66,23.6-167.2,43.39l-1.38.79,1.58,2.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 218.48,
    y: 238.03,
    width: 1.06,
    height: 38.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 230.44,
    y: 231.53,
    width: 1.06,
    height: 32.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 242.41,
    y: 225.67,
    width: 1.06,
    height: 28.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 254.37,
    y: 220.42,
    width: 1.06,
    height: 24.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 266.34,
    y: 215.82,
    width: 1.06,
    height: 21.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 278.3,
    y: 211.58,
    width: 1.06,
    height: 18.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 290.26,
    y: 207.92,
    width: 1.06,
    height: 16.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 302.23,
    y: 204.88,
    width: 1.06,
    height: 15.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 314.19,
    y: 202.04,
    width: 1.06,
    height: 13.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 326.16,
    y: 199.78,
    width: 1.06,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 338.12,
    y: 197.96,
    width: 1.06,
    height: 12.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 350.08,
    y: 196.56,
    width: 1.06,
    height: 11.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 362.05,
    y: 195.59,
    width: 1.06,
    height: 11.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 374.01,
    y: 194.85,
    width: 1.06,
    height: 11.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 384.89,
    y: 194.85,
    width: 1.06,
    height: 11.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 224.46,
    y: 236.73,
    width: 1.06,
    height: 28.75,
    transform: "translate(-84.02 116.25) rotate(-24.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 236.43,
    y: 230.03,
    width: 1.06,
    height: 25.39,
    transform: "translate(-86.34 140.03) rotate(-28.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 248.39,
    y: 223.96,
    width: 1.06,
    height: 22.61,
    transform: "translate(-86.83 167.54) rotate(-31.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 260.35,
    y: 218.5,
    width: 1.06,
    height: 20.49,
    transform: "translate(-84.46 195.27) rotate(-35.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 272.32,
    y: 213.67,
    width: 1.06,
    height: 18.84,
    transform: "translate(-79.6 223.73) rotate(-39.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 284.28,
    y: 209.18,
    width: 1.06,
    height: 17.34,
    transform: "translate(-71.7 256.34) rotate(-43.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 296.25,
    y: 205.45,
    width: 1.06,
    height: 16.94,
    transform: "translate(-64.42 272.02) rotate(-44.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 308.21,
    y: 202.27,
    width: 1.06,
    height: 16.31,
    transform: "translate(-55.41 294.08) rotate(-47.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 320.17,
    y: 199.37,
    width: 1.06,
    height: 16.08,
    transform: "translate(-47.87 307.53) rotate(-48.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 332.14,
    y: 197.07,
    width: 1.06,
    height: 15.92,
    transform: "translate(-40.89 319.76) rotate(-48.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 344.1,
    y: 195.2,
    width: 1.06,
    height: 15.72,
    transform: "translate(-33.38 333.86) rotate(-49.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 356.07,
    y: 193.88,
    width: 1.06,
    height: 16,
    transform: "translate(-31.12 334.51) rotate(-48.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 368.03,
    y: 192.94,
    width: 1.06,
    height: 16.16,
    transform: "translate(-28 338.81) rotate(-47.77)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 379.45,
    y: 192.68,
    width: 1.06,
    height: 15.77,
    transform: "translate(-33.56 317.18) rotate(-43.57)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "217.95 219.08 218.65 273.21 201.85 273.21 202.54 219.08 217.95 219.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "202.6 214.75 217.9 214.75 217.95 219.08 202.54 219.08 202.6 214.75"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "201.08 228.14 219.41 228.14 220.31 273.21 200.19 273.21 201.08 228.14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 206.92,
    y: 224.15,
    width: 6.65,
    height: 20.62,
    transform: "translate(420.49 468.92) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 212.84,
    y: 228.14,
    width: 7.44,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 200.19,
    y: 228.14,
    width: 7.44,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 206.01,
    y: 244.77,
    width: 8.45,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 212.84,
    y: 240,
    width: 7.59,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 200.04,
    y: 240,
    width: 7.59,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 203.43,
    y: 213.09,
    width: 13.6,
    height: 1.66,
    transform: "translate(420.46 427.85) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 200.19,
    y: 273.21,
    width: 20.12,
    height: 5.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 204.34,
    y: 270.46,
    width: 11.81,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 202.08,
    y: 275.95,
    width: 16.34,
    height: 3.08,
    transform: "translate(420.49 554.98) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 208.5,
    y: 222.49,
    width: 3.49,
    height: 1.66,
    transform: "translate(420.49 446.64) rotate(-180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 209.49,
    y: 79.49,
    width: 7,
    height: 199.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 204.16,
    y: 74.53,
    width: 17.67,
    height: 4.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 202.64,
    y: 39.53,
    width: 20.71,
    height: 9.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 202.64,
    y: 29.9,
    width: 20.71,
    height: 5.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 204.61,
    y: 35.44,
    width: 16.77,
    height: 4.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 212.47,
    width: 1.06,
    height: 29.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 207.85,
    y: 260.65,
    width: 10.28,
    height: 18.38,
    transform: "translate(425.99 539.68) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 201.76,
    y: 178.24,
    width: 22.46,
    height: 4.38,
    transform: "translate(425.99 360.86) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 206.78,
    y: 79.38,
    width: 1.06,
    height: 41.73,
    transform: "translate(-9.37 22.29) rotate(-6.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 121.16,
    y: 199.48,
    width: 159.02,
    height: 1.06,
    transform: "translate(-20.43 377.18) rotate(-83.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 212.47,
    y: 79.49,
    width: 1.06,
    height: 199.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 209.58,
    y: 79.47,
    width: 1.06,
    height: 41.55,
    transform: "translate(-4.83 10.83) rotate(-2.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 127.81,
    y: 199.48,
    width: 158.26,
    height: 1.06,
    transform: "translate(-3.69 396.13) rotate(-86.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 197.82,
    y: 99.71,
    width: 41.73,
    height: 1.06,
    transform: "translate(96.13 307.25) rotate(-84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 224.79,
    y: 120.5,
    width: 1.06,
    height: 159.02,
    transform: "translate(-20.81 26.25) rotate(-6.37)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 195.1,
    y: 99.71,
    width: 41.55,
    height: 1.06,
    transform: "translate(104.8 310.75) rotate(-87.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 218.52,
    y: 120.88,
    width: 1.06,
    height: 158.26,
    transform: "translate(-10.38 12) rotate(-3.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 208.55,
    y: 119.16,
    width: 8.89,
    height: 3.69,
    transform: "translate(425.99 242.01) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "195.55 66.4 230.44 66.4 230.99 62.83 195 62.83 195.55 66.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "196.79 74.53 229.2 74.53 229.53 72.33 196.46 72.33 196.79 74.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "195 62.83 230.99 62.83 231.35 60.48 194.64 60.48 195 62.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "196.46 72.33 229.53 72.33 230.08 68.75 195.91 68.75 196.46 72.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "195.91 68.75 230.08 68.75 230.44 66.4 195.55 66.4 195.91 68.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "232.8 50.98 193.19 50.98 193.74 54.55 232.25 54.55 232.8 50.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "193.74 54.55 194.1 56.9 231.89 56.9 232.25 54.55 193.74 54.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "233.12 48.86 192.87 48.86 193.19 50.98 232.8 50.98 233.12 48.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "194.64 60.48 231.35 60.48 231.89 56.9 194.1 56.9 194.64 60.48"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "532.48 227.12 542.92 254.49 518 250.07 532.48 227.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "540.05 254.49 536.36 244.8 524.82 244.8 520.86 251.08 540.05 254.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m334.17,237.09l-14.05-36.56s11.51-1.9,23.03-.95c11.51.95,17.16,3.13,17.16,3.13l.4,2.91-25.16,31.47h-1.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "339.71 230.44 360.71 205.62 366.14 245.32 359.49 242.88 339.71 230.44"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "339.71 230.44 335.56 237.09 359.49 242.88 359.76 234.58 339.71 230.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "360.71 205.62 339.71 230.44 359.76 234.58 360.71 205.62"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 264.06,
    y: 267.16,
    width: 376.04,
    height: 7.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 257.93,
    y: 275.07,
    width: 388.3,
    height: 3.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m366.14,245.32l-8.51-62.24s9.44.54,18.61,2.92c9.49,2.45,18.61,6.37,18.61,6.37l-26.42,52.95h-2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m372.47,235.9l22.87-44.47s3.39,12.44,6.09,27.74c2.7,15.3,4.27,30.9,4.27,30.9h-6.05s-27.18-14.16-27.18-14.16Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "372.47 235.9 368.44 245.32 396.37 250.07 399.65 250.07 399 241.17 372.47 235.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "395.34 191.43 372.47 235.9 372.47 235.9 399 241.17 395.34 191.43"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "380.86 245.32 366.14 245.32 366.14 267.16 396.37 267.16 396.37 250.07 380.86 245.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "343.67 237.09 334.17 237.09 325.78 241.52 313.28 241.52 313.28 267.16 366.14 267.16 366.14 245.32 343.67 237.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "627.67 263.2 602.59 255.61 546.88 255.61 546.88 267.16 627.67 267.16 627.67 263.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "549.73 264.31 549.73 258.45 602.17 258.45 621.5 264.31 549.73 264.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "527.25 250.07 396.37 250.07 396.37 267.16 546.88 267.16 546.88 255.61 527.25 250.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "302.8 267.16 302.8 255.37 322.14 255.37 330.93 260.23 333.3 260.23 343.15 265.46 343.15 267.16 302.8 267.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "308.14 248.01 308.14 255.37 322.14 255.37 310.63 248.01 308.14 248.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 500.19,
    y: 255.18,
    width: 32.29,
    height: 2.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 401.43,
    y: 255.18,
    width: 61.17,
    height: 2.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 369.62,
    y: 255.18,
    width: 23.26,
    height: 2.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 349.09,
    y: 255.18,
    width: 13.29,
    height: 2.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m532.48,227.12l10.44,27.37,44.36-37.22s-12.54-1.42-29.75,2.14c-17.21,3.56-25.05,7.72-25.05,7.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m496.87,250.07l26.71-50.61s-17.45-4.51-36.08,0-28.84,12.94-28.84,12.94l33.71,37.67h4.51Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "523.57 199.46 501.73 250.07 496.87 250.07 523.57 199.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "492.36 250.07 409.51 250.07 458.65 212.4 492.36 250.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m502.21,219.4l15.79,30.66,14.48-22.95s-4.04-2.73-14.48-4.99c-10.45-2.26-15.79-2.73-15.79-2.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "582.57 255.61 588.19 247.85 550.83 247.85 542.92 254.49 546.88 255.61 582.57 255.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "588.19 247.85 565.27 235.74 550.83 247.85 588.19 247.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "587.28 217.27 571.41 234.73 571.41 238.98 565.27 235.74 587.28 217.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m405.71,250.07s-2.22-21.21-7.28-45.42c-5.06-24.21-13.14-46.06-13.14-46.06,0,0,26.47,4.62,45.36,18.36,21.07,15.33,27.99,35.45,27.99,35.45l-49.14,37.67h-3.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "414.73 250.07 450.93 250.07 452.69 241.48 424.74 241.48 414.73 250.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "424.74 241.48 452.69 241.48 458.65 212.4 424.74 241.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "458.65 212.4 455.71 241.48 480.83 241.48 458.65 212.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "455.71 241.48 454.85 250.07 487.37 250.07 480.83 241.48 455.71 241.48"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 387.17,
    y: 259.91,
    width: 5.72,
    height: 5.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 318.33,
    y: 259.91,
    width: 5.72,
    height: 5.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 481.65,
    y: 259.91,
    width: 5.72,
    height: 5.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "m621.89,167.45s7.16,3.19,14.51,8.9c6.81,5.29,12.86,10.99,12.86,10.99v91.69h-27.38v-111.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 619.18,
    y: 208.45,
    width: 10.98,
    height: 70.58,
    transform: "translate(1249.35 487.47) rotate(-180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "629.49 279.03 650.07 279.03 650.07 193.16 625.43 193.16 629.49 279.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "630.17 182.97 663.05 190.5 658.1 279.03 633.91 279.03 630.17 182.97"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 619.35,
    y: 247.14,
    width: 53.52,
    height: 31.89,
    transform: "translate(1292.23 526.17) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 665.35,
    y: 253.47,
    width: 4.25,
    height: 25.55,
    transform: "translate(1334.94 532.5) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 658.23,
    y: 253.47,
    width: 4.25,
    height: 25.55,
    transform: "translate(1320.7 532.5) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 651.11,
    y: 253.47,
    width: 4.25,
    height: 25.55,
    transform: "translate(1306.47 532.5) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 643.99,
    y: 253.47,
    width: 4.25,
    height: 25.55,
    transform: "translate(1292.23 532.5) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 636.87,
    y: 253.47,
    width: 4.25,
    height: 25.55,
    transform: "translate(1277.99 532.5) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 629.75,
    y: 253.47,
    width: 4.25,
    height: 25.55,
    transform: "translate(1263.75 532.5) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 622.63,
    y: 253.47,
    width: 4.25,
    height: 25.55,
    transform: "translate(1249.51 532.5) rotate(-180)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 635.34,
    y: 242.02,
    width: 27.14,
    height: 5.15,
    transform: "translate(1297.81 489.2) rotate(-180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 598.85,
    y: 222.84,
    width: 40.27,
    height: 56.19,
    transform: "translate(1237.98 501.87) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 601.32,
    y: 216.92,
    width: 35.34,
    height: 5.92,
    transform: "translate(1237.98 439.76) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 626.11,
    y: 225.68,
    width: 10.55,
    height: 2.44,
    transform: "translate(1262.77 453.8) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 613.71,
    y: 225.68,
    width: 10.55,
    height: 2.44,
    transform: "translate(1237.98 453.8) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 601.32,
    y: 225.68,
    width: 10.55,
    height: 2.44,
    transform: "translate(1213.18 453.8) rotate(-180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 626.11,
    y: 229.77,
    width: 10.55,
    height: 2.44,
    transform: "translate(1262.77 461.97) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 613.71,
    y: 229.77,
    width: 10.55,
    height: 2.44,
    transform: "translate(1237.98 461.97) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 601.32,
    y: 229.77,
    width: 10.55,
    height: 2.44,
    transform: "translate(1213.18 461.97) rotate(-180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 626.11,
    y: 233.85,
    width: 10.55,
    height: 2.44,
    transform: "translate(1262.77 470.14) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 613.71,
    y: 233.85,
    width: 10.55,
    height: 2.44,
    transform: "translate(1237.98 470.14) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 601.32,
    y: 233.85,
    width: 10.55,
    height: 2.44,
    transform: "translate(1213.18 470.14) rotate(-180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 626.11,
    y: 237.94,
    width: 10.55,
    height: 2.44,
    transform: "translate(1262.77 478.31) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 613.71,
    y: 237.94,
    width: 10.55,
    height: 2.44,
    transform: "translate(1237.98 478.31) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 601.32,
    y: 237.94,
    width: 10.55,
    height: 2.44,
    transform: "translate(1213.18 478.31) rotate(-180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 626.11,
    y: 242.02,
    width: 10.55,
    height: 2.44,
    transform: "translate(1262.77 486.48) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 613.71,
    y: 242.02,
    width: 10.55,
    height: 2.44,
    transform: "translate(1237.98 486.48) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 601.32,
    y: 242.02,
    width: 10.55,
    height: 2.44,
    transform: "translate(1213.18 486.48) rotate(-180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 626.11,
    y: 246.11,
    width: 10.55,
    height: 2.44,
    transform: "translate(1262.77 494.65) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 613.71,
    y: 246.11,
    width: 10.55,
    height: 2.44,
    transform: "translate(1237.98 494.65) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 601.32,
    y: 246.11,
    width: 10.55,
    height: 2.44,
    transform: "translate(1213.18 494.65) rotate(-180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 626.11,
    y: 250.19,
    width: 10.55,
    height: 2.44,
    transform: "translate(1262.77 502.82) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 613.71,
    y: 250.19,
    width: 10.55,
    height: 2.44,
    transform: "translate(1237.98 502.82) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 601.32,
    y: 250.19,
    width: 10.55,
    height: 2.44,
    transform: "translate(1213.18 502.82) rotate(-180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 626.11,
    y: 254.28,
    width: 10.55,
    height: 2.44,
    transform: "translate(1262.77 510.99) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 613.71,
    y: 254.28,
    width: 10.55,
    height: 2.44,
    transform: "translate(1237.98 510.99) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 601.32,
    y: 254.28,
    width: 10.55,
    height: 2.44,
    transform: "translate(1213.18 510.99) rotate(-180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 626.11,
    y: 258.36,
    width: 10.55,
    height: 2.44,
    transform: "translate(1262.77 519.17) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 613.71,
    y: 258.36,
    width: 10.55,
    height: 2.44,
    transform: "translate(1237.98 519.17) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 601.32,
    y: 258.36,
    width: 10.55,
    height: 2.44,
    transform: "translate(1213.18 519.17) rotate(-180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 626.11,
    y: 262.45,
    width: 10.55,
    height: 2.44,
    transform: "translate(1262.77 527.34) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 613.71,
    y: 262.45,
    width: 10.55,
    height: 2.44,
    transform: "translate(1237.98 527.34) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 601.32,
    y: 262.45,
    width: 10.55,
    height: 2.44,
    transform: "translate(1213.18 527.34) rotate(-180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 626.11,
    y: 266.53,
    width: 10.55,
    height: 2.44,
    transform: "translate(1262.77 535.51) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 613.71,
    y: 266.53,
    width: 10.55,
    height: 2.44,
    transform: "translate(1237.98 535.51) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 601.32,
    y: 266.53,
    width: 10.55,
    height: 2.44,
    transform: "translate(1213.18 535.51) rotate(-180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 626.11,
    y: 270.62,
    width: 10.55,
    height: 2.44,
    transform: "translate(1262.77 543.68) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 613.71,
    y: 270.62,
    width: 10.55,
    height: 2.44,
    transform: "translate(1237.98 543.68) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 601.32,
    y: 270.62,
    width: 10.55,
    height: 2.44,
    transform: "translate(1213.18 543.68) rotate(-180)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "45.37 233.62 66.73 226.28 66.73 279.03 45.37 279.03 45.37 233.62"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 47.49,
    y: 238.09,
    width: 17.12,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 47.49,
    y: 241.37,
    width: 17.12,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 47.49,
    y: 244.65,
    width: 17.12,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 47.49,
    y: 247.93,
    width: 17.12,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 47.49,
    y: 251.21,
    width: 17.12,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 47.49,
    y: 254.49,
    width: 17.12,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 47.49,
    y: 257.77,
    width: 17.12,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 47.49,
    y: 261.05,
    width: 17.12,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 47.49,
    y: 264.33,
    width: 17.12,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 47.49,
    y: 267.61,
    width: 17.12,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 47.49,
    y: 270.88,
    width: 17.12,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 47.49,
    y: 274.16,
    width: 17.12,
    height: 1.78
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-68",
    cx: 325.79,
    cy: 411.12,
    rx: 237.23,
    ry: 5.86
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m523.94,289.48s-1.21-3.69-3.15-4.12c-1.94-.42-3.63.47-5.02,3.99-1.39,3.52,8.17.13,8.17.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "m100.96,222.88c-1.77.25-2.3,1.98-.67,3.66,1.63,1.68,14,1.75,14,1.75,0,0,21.82,4.25,27.44,3.44,5.62-.81-.42-4.38-.42-4.38l-40.34-4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "m407.55,233.8c-.59-1.9-46.44-17.69-114.31-17.69-67.88,0-185.75,5.95-190.07,6.52l-2.2.24s28.86,8.11,42.57,8.11c13.71,0,161.26,4.86,161.26,4.86l102.76-2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "m526.25,294.72s-9.8-6.67-44.43-25.5c-34.63-18.83-74.27-35.42-74.27-35.42,0,0-10.4-.26-12.9.79-2.5,1.05,55.44,60.28,85.86,58.65,30.42-1.63,45.75,1.49,45.75,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m398.39,234.01l-12.26-.73s-27.99-8.77-73.63-8.77c-91.17,0-150.28,6.47-168.97,6.47s-29.24-2.7-29.24-2.7c.4.84,1.8,1.88,1.8,1.88,0,0-4.86,4.55-14.63,15.26-9.77,10.71-17.79,25.64-18.56,26s-1.9.65-4.9.63l1.72,2.16,147.25,8.73,194.46,14.15,80.52-7.76s-43.38-33.19-103.56-55.33Zm-195.66,4.12l-4.45,18.87c-1.03,4.38-4.98,7.44-9.48,7.36l-47.06-.83c-2.81-.05-4.55-3.09-3.16-5.54l4.21-7.4c4.9-8.61,13.77-14.2,23.65-14.91l32.25-2.29c2.6-.18,4.63,2.2,4.03,4.74Zm113.01,38.95c-19.29-.82-76.1-3.23-98.22-4.11-2.84-.11-4.93-2.7-4.46-5.51,3.22-19.15,7.07-31.61,8.63-36.25.41-1.22,1.55-2.04,2.84-2.05l91.68-.87c1.61-.02,2.94,1.23,3.05,2.83l2.59,39.72c.23,3.48-2.61,6.39-6.1,6.24Zm121.63,5.83c-24.35-.41-80.09-3.75-93.05-4.54-1.6-.1-2.92-1.28-3.2-2.86l-8.16-46.33c59.94,0,92.36,25.73,98.3,30.14,4.28,3.18,7.69,13.44,9.37,19.37.61,2.14-1.03,4.26-3.25,4.23Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-130"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m332.96,229.18c59.94,0,92.36,25.73,98.3,30.14,4.28,3.18,7.69,13.44,9.37,19.37.61,2.14-1.03,4.26-3.25,4.23-24.35-.41-80.09-3.75-93.05-4.54-1.6-.1-2.92-1.28-3.2-2.86l-8.16-46.33Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m332.96,279.79s-6.61-54.67-7.07-57.28-6.12-2.9-21.05-3.34c-14.94-.44-70.48.87-79.47,1.16-8.99.29-8.27,5.51-10.59,11.75-2.32,6.24-12.98,47.71-12.98,47.71"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "m207.75,288.76l-127.46-11.4s-4.9,13.34-4.75,17.45,5.68,27.84,1.7,32.75l-3.97,4.91,25.1,22.29,133.83-6.13-24.44-59.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "m458.42,299.29c-44.85-3.34-257.77-15.01-257.77-15.01,0,0-3.08,12.6-4.08,22.15-1.21,11.61,15.26,30.48,18.41,40.36,3.15,9.88,53.82,14.03,53.82,14.03l187.5-.13,2.13-61.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "m451.98,298.77c4.13,18.94.56,49.67-.6,64.1,16.46,1.92,110.63-6.2,110.63-6.2,0,0,10.08-44.12-33.48-51.93-43.57-7.81-76.55-5.98-76.55-5.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "m511.1,289.2s31.29,16.09,36.18,24c0,0,14.06-1.8-18.09-4.32-20.64-1.62-114.68-6.31-195.69-11.19-45.16-2.72-87.45-5.18-110.86-6.48-65.41-3.64-129.65-12.14-129.65-12.14,0,0-9.08-6.55,35.87-6.04,44.95.51,191.36,8.93,230.69,11.14,39.33,2.21,114.7,6.02,151.55,5.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "m332.96,282.95s.88,8.58.88,16.86c0,12.94.74,48.92.74,62.36,0,6.96.29,16.62.29,16.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "m530.15,327.92l13.65-13.65s21.42.17,27.38,27.21c5.96,27.05-4.14,25.51-4.14,25.51l-42.1-5.76,5.21-33.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "m559.35,323.15c3.83,2.74,9.44,16.79,10.13,25.48l.69,8.69s8.33,9.51,1.99,17.01c7.94-14.87,8.97-17.65,8.97-17.65h5.58s.62.17.62-3.46c0-3.63-.12-16.58-5.32-22.84-5.2-6.26-22.66-7.22-22.66-7.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "m523.18,287.75c1.68-.23,5.68.6,7.28,1.16,2.79.97,8.35,2.83,14.91,7.18,11.05,7.32,25.1,16.9,32.57,28.12l-32.57-13.04s-12.3-10.01-23.29-15.99l-10.98-5.98s4.81-.46,12.08-1.45Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-60",
    x1: 542.64,
    y1: 315.52,
    x2: 528.52,
    y2: 329.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "m573.19,361.38s-105.8-3.19-180.16-8.17c-74.36-4.98-162.77-14.7-194.39-2.31-31.62,12.39-71.06-43.32-120.65-5.06,0,0,69.96,19.34,166.32,21.86,96.36,2.53,314.36,8.28,314.36,8.28,0,0,11.42,2.9,13.82.14,2.4-2.76.7-14.73.7-14.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m586.71,356.67s-4.31-3.75-14.55-2.92c-2.29.42-2.99,1.64-1.28,5.37,1.52,3.31,2.77,12.88-2.67,12.83-.54,5.25,15.99,4.48,18.51,3.31,2.52-1.16-3.45-5.31-3.45-5.31-1.71-3.69-2.7-9.03-1.71-11.22.99-2.18,5.16-2.07,5.16-2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m576.07,364.65c0,2.04.34,4.85-.86,5.56-1.2.71-3.04-1.69-2.66-3.21s.64-5.62.64-5.62l2.88,3.27Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 77.24,
    y1: 320.52,
    x2: 166.11,
    y2: 330.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m218.83,375.13s-3.06-2.55-3.06-5.88c0-19.71-5.03-50.8-43.69-50.8-37.93,0-47.15,26.47-47.15,49.33,0,2.39.46,3.32.46,3.32l93.44,4.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "m586.71,375.27s-6.89.06-11.81-1.91c-4.91-1.97-10-1.42-15.17-1.42-5.17,0-42.31-.92-42.31-.92,0,0-10.68.19-57.73-1.44s-178.94-6.58-208.2-10.37c-29.26-3.79-58.73-7.21-58.73-7.21,0,0-91.37-11.22-98.23-12.48-6.86-1.26-21.27-7.06-21.27-7.06,0,0-3.03,4.68-2.07,13.41.97,8.72,1.34,9.55,2.47,10.75,1.13,1.2-2.48,3.31-1.13,5.49,1.35,2.18,51.74,11.66,51.74,11.66l99.2,2.8,277.69,4.31h60.06s18.58-2.07,19.89-2.16,5.19-2.28,5.58-3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m538.58,379.27l42.55-.48s-7.12,6.04-25.49,6.22c-18.36.18-20.17,0-20.17,0l3.11-5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m128.18,273.03h.68s-28.98,12.17-50.87,16.86l-2.83.28.4-1.41,43.02-14.44,9.59-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m76.76,281.71s1.79-4.23,1.79-5.61c0-1.78-.47-2.01-1.45-2.71-.6-.42-.5-1.57.88-1.32,5.31.96,11.51,1.23,18.62,1.23,7.92,0,31.57-.27,31.57-.27,0,0-22.19,8.32-39.95,12.62-12.12,2.13-11.47-3.94-11.47-3.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m125.39,371.1c-25.82-4.16-52.13-8.57-52.13-8.57v.91c0,2.58,1.55,4.92,3.94,5.9,2.33.96,5.53,2.82,9.12,6.44,1.12,1.14,2.64,1.8,4.23,1.88,11.2.58,35.45,2.8,35.45,2.8l-.61-9.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "m550.19,376.97s4.86-5.29,4.86-8.62c0-19.71-12.15-48.06-51.61-48.06-37.93,0-47.15,26.47-47.15,49.33v6.61s93.9.74,93.9.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m546.86,385.01s2.36-2.89,2.36-6.22c0-19.71-4.33-50.47-46.38-50.47-35.73,0-44.41,26.47-44.41,49.33v6.61s88.44.74,88.44.74Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-76",
    cx: 502.82,
    cy: 374.33,
    r: 38.42
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-69",
    cx: 502.83,
    cy: 374.33,
    r: 25.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-71",
    cx: 502.83,
    cy: 374.33,
    r: 23.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-69",
    cx: 502.83,
    cy: 374.33,
    r: 21.12
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 500.51,
    y: 352.08,
    width: 4.63,
    height: 44.5,
    transform: "translate(1005.65 748.65) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 500.51,
    y: 352.6,
    width: 4.63,
    height: 43.45,
    transform: "translate(877.16 -128.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 500.51,
    y: 352.01,
    width: 4.63,
    height: 44.63,
    transform: "translate(411.96 -245.91) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 500.51,
    y: 352.21,
    width: 4.63,
    height: 44.24,
    transform: "translate(1123.07 283.48) rotate(135)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-120",
    cx: 509.45,
    cy: 374.33,
    r: 1.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-120",
    cx: 496.2,
    cy: 374.33,
    r: 1.65
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-120",
    cx: 502.82,
    cy: 367.7,
    r: 1.65,
    transform: "translate(-105.67 501.01) rotate(-48.53)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-120",
    cx: 502.82,
    cy: 380.96,
    r: 1.65,
    transform: "translate(-115.6 505.49) rotate(-48.53)"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-120",
    cx: 502.83,
    cy: 374.33,
    r: 3.23
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m213.37,385.01s2.36-2.89,2.36-6.22c.64-19.83-3.77-52.07-45.82-52.07-35.73,0-45.54,26.49-44.97,50.94,0,2.39,0,6.61,0,6.61l88.44.74Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-76",
    cx: 169.33,
    cy: 374.33,
    r: 38.42
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-69",
    cx: 169.34,
    cy: 374.33,
    r: 25.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-71",
    cx: 169.34,
    cy: 374.33,
    r: 23.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-69",
    cx: 169.34,
    cy: 374.33,
    r: 21.12
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 167.02,
    y: 352.08,
    width: 4.63,
    height: 44.5,
    transform: "translate(338.67 748.65) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 167.03,
    y: 352.6,
    width: 4.63,
    height: 43.45,
    transform: "translate(543.67 204.99) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 167.02,
    y: 352.01,
    width: 4.63,
    height: 44.63,
    transform: "translate(314.28 -10.1) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 167.02,
    y: 352.21,
    width: 4.63,
    height: 44.24,
    transform: "translate(553.76 519.28) rotate(135)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-120",
    cx: 175.96,
    cy: 374.33,
    r: 1.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-120",
    cx: 162.71,
    cy: 374.33,
    r: 1.65
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-120",
    cx: 169.34,
    cy: 367.7,
    r: 1.65,
    transform: "translate(-218.33 251.11) rotate(-48.53)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-120",
    cx: 169.33,
    cy: 380.96,
    r: 1.65,
    transform: "translate(-228.26 255.59) rotate(-48.53)"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-120",
    cx: 169.34,
    cy: 374.33,
    r: 3.23
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m458.42,377.66l-243-4.23.7,3.72.25,3.58c.07,1.08.97,1.91,2.05,1.92l220.84.57s3.02,3.73,10.58,3.73c7.56,0,8.59-2.68,8.59-2.68v-6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m71.2,338.44s3.27.38,5.38.63c.51.06.81.61.58,1.07-.36.74-.64,1.57-.8,2.12-.11.35-.46.57-.83.52l-4.33-.66v-3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "m75.17,290.17c0,7.23-1.31,9.96.66,16.42s2.33,22.55-2.56,25.94c3.87-1.42,9.45-5.69,9.45-12.59,0-6.9-4.29-20.6-4.73-24.41s0-5.64,0-5.64l-2.83.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m75.57,288.76s15.2-3.3,21.17-5.36c-12.42,1.3-19.38-1.69-19.97-1.69-1.52,5.1-1.19,7.05-1.19,7.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m578.8,362.96c.86,4.22,2.88,6.43,3.17,7.39s-.96,1.58-3.74.74c-2.78-.84-1.92-9.19.58-8.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m572.15,360.69s2.61-1.68,3.91-.71-.1,4.1,0,4.68c-1.93-1.88-3.13-1.67-3.13-1.67,0,0-.16-1.6-.79-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m572.15,360.69c.6,1.01.79,5.54.39,6.31,1.24-2.95,1.15-5.36-.39-6.31Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m583.1,329.7c-1.34,1.83-8.06.75-16.07-2.77-8.01-3.52-28.83-10.73-34.46-13.05-5.63-2.32-9.26-4.74-9.26-4.74.3-1.2,14.77-1,22.37.68,7.6,1.69,20.71,4.6,22.61,6.71,1.9,2.11,10.86,6.59,10.86,6.59,3.52,2.67,3.95,6.58,3.95,6.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m582.82,329.89c-1.34,1.83-6.63.42-14.64-3.09-8.01-3.52-31.5-12.45-37.12-14.77s-7.12-2.95-7.12-2.95c1.85-.49,13.1-.21,20.69,1.48,7.6,1.69,22.29,5.13,24.19,7.24,1.9,2.11,10.48,9.42,10.48,9.42l3.52,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m563.83,319.48c-.63-2.18-3.8-4.36-7.17-2.32-3.38,2.04-1.27,4.92-1.27,4.92-2.81-1.27-1.62-3.73-1.62-3.73,1.76-3.45,8.65-4.5,10.06,1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m549.21,316.53s2.88.54,3.3,2.27l.42,1.74s-2.67-.56-2.81-1.2-.97-1.69-.91-2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m568.83,317.79c.77,4.57,5.24,5.88,10.48,9.42.07-4.43-8.37-6.68-10.48-9.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m158.5,290.02l-15.89-.58c-2.6-.09-4.78,1.92-4.9,4.52l-.35,7.75c-.14,3.07,2.25,5.68,5.32,5.8l16.13.65c2.11.09,3.86-1.6,3.86-3.71v-10.1c0-2.33-1.85-4.25-4.18-4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m448.59,288.42s4.01,10.21,5.1,18.41.36,50.87-2.55,62.44c-.55,5.2-.91,8.03-.91,8.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m202.94,275.71s-5.17,16.86-6.31,32.45c-1.15,15.58,14.51,20.65,21.49,48.52,3.66,14.61,2.89,22.72,2.89,22.72"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-133",
    cx: 352.92,
    cy: 298.99,
    rx: 5.75,
    ry: 7.57,
    transform: "translate(38.1 637.86) rotate(-87.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "m338.78,298.18c-.05.85.6,1.57,1.44,1.62l23.49,1c.85.05,1.57-.6,1.62-1.44h0c.05-.85-.6-1.57-1.44-1.62l-23.49-1c-.85-.05-1.57.6-1.62,1.44h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-146",
    cx: 316.44,
    cy: 297.34,
    rx: 5.75,
    ry: 7.57,
    transform: "translate(1 595.74) rotate(-86.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "m302.32,296.34c-.06.84.58,1.58,1.42,1.64l23.48,1.31c.84.06,1.58-.58,1.64-1.42h0c.06-.84-.58-1.58-1.42-1.64l-23.48-1.31c-.84-.06-1.58.58-1.64,1.42h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m445.66,265.14c7.48,3.77,20.78,10.85,26.2,16.06.91.88.27,2.42-.99,2.42h-17.96c-1.66,0-3.17-.96-3.88-2.47l-6.19-13.26c-.84-1.79,1.06-3.64,2.82-2.74Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "m438.35,279.24s-1.48,3.26-1.34,5.04c.06.74.36,1.16.71,1.4.27.19.13.62-.2.61-.49,0-1.1-.16-1.75-.62-1.65-1.18-3.04-1.39-3.04-1.39l4.73-6.08.89,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "m432.73,279.33c-.09,1.2-1.95,2.84-3.61,3.15-.21.04-.24.32-.04.41,3.22,1.37,3.66,1.39,3.66,1.39,4.23-.79,4.27-7.16,4.27-7.16l-4.27,2.22Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "m442.95,278.92c.86-2.81-2.29-12.65-7.79-13.5-2.49-.51-5.48-.25-6.35.67s-.9,7.5-.9,7.5l.41,3.23,14.63,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "m435.16,265.41c-2.95-.44-4.8-.37-5.24,1.84s-.89,11.66-.89,11.66c-2.11-.96-3.59-1.01-3.54-2.66.06-2.14.6-7.61,1.19-9.38.59-1.77,4.05-2.27,8.48-1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "m435.96,272.75c2.66.85,2.72,4.3,1.98,4.07-1.14-.36-2.12-.74-3.9-.96-1.79-.22-4.22-.17-5.41-.17-1.36,0-3.1.07-3.1.07l.22-3.73s1.75-.21,3.7-.18c3.26.05,6.52.9,6.52.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "m429.03,278.92s4.27.38,6.12.83c1.86.45,4.69,1.31,5.76,1.47,1.37.2,2.03-2.3,2.03-2.3,0,0-5.73-2.29-8.62-2.69s-8.84-.19-8.84-.19c0,0-.19,2.52,1.68,2.7l1.86.18Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-130"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m316.2,228.29l-91.68.87c-1.29.01-2.42.83-2.84,2.05-1.57,4.64-5.41,17.1-8.63,36.25-.47,2.81,1.62,5.4,4.46,5.51,22.12.88,78.93,3.29,98.22,4.11,3.49.15,6.32-2.76,6.1-6.24l-2.59-39.72c-.1-1.6-1.44-2.84-3.05-2.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-130"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m198.7,233.4l-32.25,2.29c-9.88.7-18.76,6.29-23.65,14.91l-4.21,7.4c-1.39,2.45.34,5.49,3.16,5.54l47.06.83c4.5.08,8.44-2.99,9.48-7.36l4.45-18.87c.6-2.53-1.43-4.92-4.03-4.74Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "m116.09,230.18c5.82,2.52,16.7,3.06,16.7,3.06,0,0-29.09,18.34-36.92,31.84-5.15,8.56-17.87,6.99-17.87,6.99,0,0,4.5.39,7.42-4.37,1.4-2.28,7.09-11.62,14.12-20.08,7.62-9.18,16.55-17.44,16.55-17.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-129"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "382.15 280.55 394.75 281.21 381.21 235.28 368.18 232.35 382.15 280.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "372.25 280 377.16 280.28 363.97 231.63 359.4 230.89 372.25 280"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-129"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "284.3 275.75 296.86 276.28 282.81 228.61 270.68 228.72 284.3 275.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "260.47 274.74 279.32 275.54 266.65 228.76 248.65 228.93 260.47 274.74"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-129"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "175.25 264.12 187.72 264.34 179.01 234.79 167 235.65 175.25 264.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m151.54,263.62l18.77.41-7.55-27.85c-4.82,1.04-10.49,3.07-15.98,8.97l4.76,18.47Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m114.29,228.29s10.55,2.7,29.24,2.7c18.69,0,77.8-6.47,168.97-6.47,45.64,0,73.63,8.77,73.63,8.77l12.26.73c12.82,4.72,24.88,9.93,35.92,15.23,10.05,4.82-24,3.87-73.82-5.8-49.82-9.67-64.6,18.31-133.7,2.65-69.1-15.66-135.11,10.06-125.33-.65,9.77-10.71,14.63-15.26,14.63-15.26,0,0-1.4-1.05-1.8-1.88Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHybridIllustration);
export default __webpack_public_path__ + "static/media/Hybrid-illustration.c0bb4a7ed5bb3021983d92f08a16c590.svg";
export { ForwardRef as ReactComponent };